var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsLetterImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 221,
    viewBox: "0 0 186 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8845 164.059H26.2358V270.464H29.8845V164.059Z",
    fill: "#2A272D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.979 142.18L48.1139 190.185L64.6463 256.874H79.6512L68.9455 182.759L21.979 142.18Z",
    fill: "#232322"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5456 162.49H10.877C6.19587 162.49 2.3916 158.699 2.3916 154.003C2.3916 149.322 6.18173 145.517 10.877 145.517H43.5456C48.2267 145.517 52.0309 149.322 52.0309 154.003C52.0309 158.699 48.2267 162.49 43.5456 162.49Z",
    fill: "#FFEEE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7435 162.495H12.3477V165.635H43.7435V162.495Z",
    fill: "#2A272D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.363 55.2374C20.0697 54.4737 14.1017 58.2784 11.6975 64.134C9.66101 69.0702 7.96391 76.2271 9.77412 84.5296C15.2896 109.946 11.9945 127.527 11.9945 127.527H41.8771L41.764 92.917C41.764 92.917 43.8288 88.8859 44.946 83.6102C46.5158 76.2271 45.9218 75.2653 41.6084 68.7308L32.4301 57.5287C32.4442 57.5287 30.3936 55.7183 26.363 55.2374Z",
    fill: "#F8D4D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7124 79.764C82.7065 75.7754 87.5432 74.163 91.5313 76.1573C95.5194 78.1516 97.1316 82.9889 95.1375 86.9775C93.1435 90.9661 88.3068 92.5785 84.3187 90.5842C80.3306 88.604 78.7183 83.7526 80.7124 79.764Z",
    fill: "#FCC9A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4798 77.4292L67.291 91.856L73.061 98.2774L84.8982 88.1362L82.4798 77.4292Z",
    fill: "#FCC9A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1244 77.6271L43.6029 119.394C44.6635 120.993 46.8415 121.374 48.383 120.215L81.5466 94.1614L74.829 82.6341L49.1749 102.238L31.2425 69.07C28.8525 64.0913 22.5026 62.5779 18.1185 65.9159C14.4698 68.6881 13.6071 73.8082 16.1244 77.6271Z",
    fill: "#F8D4D5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0878 61.5617C26.3483 61.5475 24.4957 60.8262 23.1238 60.119C21.7662 59.4259 20.9177 57.9974 20.9318 56.4698L21.2147 28.4082L33.476 28.4648L33.1932 56.1728C33.179 59.3552 30.888 61.5758 28.0878 61.5617Z",
    fill: "#FCC9A7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2782 48.3927L28.2153 41.2217C28.2153 41.2217 25.1181 49.4111 33.2499 51.9287L33.2782 48.3927Z",
    fill: "#F2C09E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3238 28.5194C44.2814 36.8785 37.4789 43.6111 29.1208 43.5686C20.7628 43.5262 14.031 36.723 14.0734 28.3639C14.1159 20.0048 20.9183 13.2722 29.2764 13.3147C37.6203 13.3571 44.3521 20.1603 44.3238 28.5194Z",
    fill: "#FCC9A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3534 48.4787C30.3936 48.4645 27.1833 45.2255 27.2116 41.2652L27.254 30.9118L44.3096 28.5215L44.2672 38.6627C44.2389 44.1082 39.8124 48.5069 34.3534 48.4787Z",
    fill: "#FCC9A7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8573 31.8984L47.1383 36.7781C47.605 37.5701 46.9968 38.5461 46.021 38.5461L42.1885 39.2533L43.8573 31.8984Z",
    fill: "#FCC9A7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2676 35.0524L33.7023 34.8261C33.7023 34.8261 34.2539 29.2392 35.5125 27.8956C36.7712 26.5519 37.4076 20.5831 37.4076 20.5831C37.4076 20.5831 34.367 24.303 33.4761 28.1502L46.9536 27.8107C46.9536 27.8107 48.9619 11.4603 28.5546 10.6682C8.13313 9.87614 8.6988 29.1968 12.7152 33.0298C15.9114 36.0849 21.0874 43.5813 21.0874 43.5813C21.0874 43.5813 20.847 35.2787 27.2676 35.0524Z",
    fill: "#4C1827"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9352 33.0742C32.02 35.4645 30.1533 37.4588 27.7774 37.5437C25.3873 37.6285 23.3933 35.7615 23.2943 33.3853C23.2094 30.995 25.0762 29.0007 27.4521 28.9017C29.8421 28.8168 31.8362 30.6838 31.9352 33.0742Z",
    fill: "#FCC9A7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4615 8.57592C20.112 13.9365 16.3078 18.802 10.962 19.4668C5.60207 20.1174 0.737108 16.3127 0.0724212 10.9521C-0.578123 5.59155 3.22613 0.726022 8.58605 0.0753995C13.946 -0.589367 18.8109 3.21535 19.4615 8.57592Z",
    fill: "#4C1827"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4131 58.4035C21.4131 58.4035 22.5869 62.0668 38.9637 65.4755L31.3551 55.1221L21.4131 58.4035Z",
    fill: "#FCC9A7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7148 220.101L17.708 234.542L26.3348 237.823L38.384 222.534L29.7148 220.101Z",
    fill: "#FCC9A7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1319 127.529C11.1319 127.529 2.1374 148.009 34.0989 158.914L56.1892 179.437L21.9932 225.235L37.281 230.766L78.8027 186.58C81.8716 183.001 81.9988 177.514 79.0997 173.78L41.8913 127.515H11.1319V127.529Z",
    fill: "#383635"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.053 109.436H75.8608V115.517H185.053V109.436Z",
    fill: "#FFEEE3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.717 272.633V115.521",
    stroke: "#2A272D",
    strokeWidth: 12.9359,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.32 272.633V115.521",
    stroke: "#2A272D",
    strokeWidth: 12.9359,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.423 106.124H98.9976V109.065H144.423V106.124Z",
    fill: "#2A272D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.423 109.081L159.131 66.1403L156.048 65.4048L141.637 106.649L144.423 109.081Z",
    fill: "#2A272D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4947 116.197L19.5601 82.8452",
    stroke: "#F0A8AA",
    strokeWidth: 4.44997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8244 90.0288L34.4521 76.79",
    stroke: "#F0A8AA",
    strokeWidth: 4.44997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLetterImg);
export default __webpack_public_path__ + "static/media/newsLetterImg.853e896a.svg";
export { ForwardRef as ReactComponent };